// extracted by mini-css-extract-plugin
module.exports = {"titleListWrapper":"pu","titleListTabWrapper":"pv","tab":"pw","active":"px"};